import React, { useEffect, useState, useRef, useMemo } from 'react';

const MobileProductAccordion = ({
    selectedParentCategory,
    categories,
    onProductSelect,
    setResult,
    product,
    setSelectedProduct,
    setSelectedSubCategory,
    setSelectedSubCategorySlug,
    allProducts, // Receive all products as a prop
    loadingProducts,
}) => {
    const [openSubcategory, setOpenSubcategory] = useState(null);
    const subcategoryRefs = useRef({});

    const subCategories = useMemo(() => 
        categories.filter(cat => cat.parent === selectedParentCategory),
        [categories, selectedParentCategory]
    );

    // Filter products by category
    const productsBySubcategory = useMemo(() => {
        const categorizedProducts = {};

        const categoriesToFetch = subCategories.length > 0 
            ? subCategories 
            : [{ id: selectedParentCategory, name: 'All', slug: 'all' }];

        categoriesToFetch.forEach(category => {
            const productsInCategory = allProducts.filter(product =>
                product.categories.includes(category.id)
            );

            categorizedProducts[category.id] = {
                name: category.name,
                slug: category.slug,
                products: productsInCategory,
            };
        });

        return categorizedProducts;
    }, [allProducts, subCategories, selectedParentCategory]);

    const toggleSubcategory = (subcategoryId) => {
        const isOpening = openSubcategory !== subcategoryId;
        setOpenSubcategory(isOpening ? subcategoryId : null);

        if (isOpening) {
            setTimeout(() => {
                subcategoryRefs.current[subcategoryId]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    };

    const handleProductSelect = (selectedProduct, subcategoryId) => {
        setResult(null);
        setSelectedProduct(selectedProduct);
        onProductSelect(selectedProduct);

        if (subCategories.length > 0) {
            const selectedSubcategory = categories.find(cat => cat.id === parseInt(subcategoryId));
            if (selectedSubcategory) {
                setSelectedSubCategory(selectedSubcategory.id);
                setSelectedSubCategorySlug(selectedSubcategory.slug);
            }
        }

        setOpenSubcategory(subcategoryId);
    };

    const renderProductItem = (prod, subcategoryId) => (
        <label
            key={prod.id}
            className={`product-${prod.id} ${product?.id === prod.id ? 'selected' : ''}`}
        >
            <div className='radio-product'>
                <input
                    type="radio"
                    name="product"
                    value={prod.id}
                    checked={product?.id === prod.id}
                    onChange={() => handleProductSelect(prod, subcategoryId)}
                    className='mobile-cat-radio'
                    style={{ marginTop: "8px" }}
                />
                <div className='product-title'>
                    {(() => {
                        const titleText = prod.title.rendered
                            .replace(/&#8211;/g, '-')
                            .replace(/&amp;/g, '&');

                        if (titleText.includes('(') && titleText.includes(')')) {
                            const firstBracketIndex = titleText.indexOf('(');
                            const lastBracketIndex = titleText.lastIndexOf(')');

                            const titleWithoutBrackets = titleText.substring(0, firstBracketIndex).trim();
                            let bracketContent = titleText.substring(firstBracketIndex + 1, lastBracketIndex).trim();
                            bracketContent = bracketContent.replace(/\(|\)/g, '');

                            return (
                                <>
                                    <span style={{ fontSize: '16px', color: "#575551" }}>
                                        {titleWithoutBrackets}
                                    </span>
                                    <br />
                                    <span style={{ fontSize: '12px', color: '#706F6F' }}>
                                        {bracketContent}
                                    </span>
                                </>
                            );
                        }

                        return <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{titleText}</span>;
                    })()}
                </div>
            </div>
        </label>
    );

    if (loadingProducts) {
        return <div>Loading products...</div>;
    }

    return (
        <div className="mobile-product-accordion">
            <label className="uk-form-label uk-display-block">
                Insulation Solution
            </label>
            {Object.entries(productsBySubcategory).length <= 1 ? (
                <div className="accordion-content" style={{ padding: "16px" }}>
                    {Object.entries(productsBySubcategory).map(([subcategoryId, { products }]) =>
                        products.map(prod => renderProductItem(prod, subcategoryId))
                    )}
                </div>
            ) : (
                Object.entries(productsBySubcategory).map(([subcategoryId, { name, products }]) => (
                    <div
                        key={subcategoryId}
                        ref={(el) => (subcategoryRefs.current[subcategoryId] = el)}
                        className="accordion-item"
                        style={{ backgroundColor: "#F6F7F9" }}
                    >
                        <div
                            className={`accordion-header ${openSubcategory === subcategoryId ? 'active' : ''}`}
                            onClick={() => toggleSubcategory(subcategoryId)}
                        >
                            {name}
                            <img
                                src="/Arrow.svg"
                                alt="Arrow Icon"
                                className={`accordion-arrow ${openSubcategory === subcategoryId ? 'rotated' : ''}`}
                            />
                        </div>
                        {openSubcategory === subcategoryId && (
                            <div className="accordion-content">
                                {products.map(prod => renderProductItem(prod, subcategoryId))}
                            </div>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default MobileProductAccordion;